import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import classNames from 'classnames'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            textError: {
                textAlign: 'center'
            }
        })
)

const NotFound = () => {
    const classes = useStyle()
    return (
        <div>
            <p className={classNames(classes.title0, classes.textError)}>404</p>
        </div>
    )
}

export default NotFound
